import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Table } from "react-bootstrap";

import { Loading } from "../../../common/loading/loading";
import { Pager } from "../../../common/pager/pager";

export const ScheduledLogTable = ({
  job,
  currentPage,
  rowInit,
  allPage,
  logs,
  handleChangePage,
}) => {
  const LogTableBody = ({ rowInit, logs }) => {
    if (logs.length === 0) {
      return (
        <tbody>
          <tr>
            <td colSpan={4}>
              <span className="text-danger">
                <b>
                  <FormattedMessage id="page.scheduledjobs.label.onsiteloglist" />
                </b>
              </span>
            </td>
          </tr>
        </tbody>
      );
    }

    return (
      <tbody>
        {logs.map((log, index) => (
          <tr key={index}>
            <th className="col-no">{+rowInit + index + 1}.</th>
            <th className="col-status">
              <FormattedMessage
                id={`data.scheduledjoblogs.data.status.value.${log.status}`}
              />
            </th>
            <th className="col-date">{log.logDate}</th>
            <th className="col-log">{log.msg}</th>
          </tr>
        ))}
      </tbody>
    );
  };

  const LogTable = ({
    currentPage,
    rowInit,
    allPage,
    logs,
    handleChangePage,
  }) => (
    <Pager
      currentPage={currentPage}
      allPage={allPage}
      topPager={true}
      bottomPager={true}
      handleChangePage={handleChangePage}
    >
      <div className="jobs-logs-component table-responsive">
        <Table striped bordered>
          <thead>
            <tr>
              <th className="col-no"></th>
              <th className="col-status">
                <FormattedMessage id="data.scheduledjoblogs.data.status.label" />
              </th>
              <th className="col-date">
                <FormattedMessage id="data.scheduledjoblogs.data.date" />
              </th>
              <th className="col-log">
                <FormattedMessage id="data.scheduledjoblogs.data.msg" />
              </th>
            </tr>
          </thead>
          <LogTableBody rowInit={rowInit} logs={logs} />
        </Table>
      </div>
    </Pager>
  );

  return (
    <>
      <hr />
      <div>
        <u>{job.className}</u>
      </div>
      {logs ? (
        <LogTable
          currentPage={currentPage}
          rowInit={rowInit}
          allPage={allPage}
          logs={logs}
          handleChangePage={handleChangePage}
        />
      ) : (
        <Loading />
      )}
    </>
  );
};

ScheduledLogTable.propTypes = {
  job: PropTypes.object.isRequired,
  currentPage: PropTypes.number.isRequired,
  rowInit: PropTypes.number.isRequired,
  allPage: PropTypes.number.isRequired,
  logs: PropTypes.array,
  handleChangePage: PropTypes.func.isRequired,
};
